export default {
  'Snapshot.List.Item': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'product',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: ({ gid, goodsCount }) => {
        return `skuid=${gid}&quantity=${goodsCount}`;
      },
    },
  },
  'Snapshot.Detail.ProductEnter': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'product_enter',
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: ({ pid }) => {
        return `pid=${pid}`;
      },
    },
  },
};
